import {share, tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';

@Injectable()
export class GetRelevantDataInterceptor implements HttpInterceptor {

  private sessionCache: Map<string, HttpResponse<any>> = new Map();
  private cachedTime: number;
  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.endsWith('records/relevant-data')) {
      const cachedResponse: HttpResponse<any> = this.sessionCache.get(request.url);
      if (cachedResponse && (Date.now() - this.cachedTime) < 6000) {
        return of(cachedResponse.clone());
      } else {
        return next.handle(request).pipe(tap(stateEvent => {
          if (stateEvent instanceof HttpResponse) {
            this.cachedTime = Date.now();
            this.sessionCache.set(request.url, stateEvent.clone());
          }
        }), share());
      }
    } else {
      return next.handle(request);
    }
  }
}
